/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Option_Remove_LoadingInputs */

const fr_membership_option_remove_loading = /** @type {(inputs: Membership_Option_Remove_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrait en cours...`)
};

/**

* @param {Membership_Option_Remove_LoadingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_remove_loading = /** @type {((inputs?: Membership_Option_Remove_LoadingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Remove_LoadingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_remove_loading(inputs)
});